// frontend/src/pages/dashboard/TaskComponents/TaskHeader.js

import React from "react";
import { Box, Typography, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import FlagIcon from "@mui/icons-material/Flag";
import ViewKanbanIcon from "@mui/icons-material/ViewKanban";
import { useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from 'react-router-dom';

const TaskHeader = ({ filteredTasksCount, hasPermission, onAddTask, projectId }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 3,
        flexWrap: "wrap",
        gap: 2,
      }}
    >
      <Box>
        <Typography variant="h4" fontWeight={600}>
          All Tasks
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Manage your workspace tasks ({filteredTasksCount} active task
          {filteredTasksCount !== 1 ? "s" : ""})
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>
        
        {/* View Board Button - ONLY SHOW IF projectId EXISTS */}
        {projectId && (
          <Button
            variant="outlined"
            startIcon={<ViewKanbanIcon />}
            onClick={() => navigate(`/projects/${projectId}/board`)}
            sx={{
              height: 48,
              px: 2.5,
              borderRadius: 3,
              fontWeight: 600,
              borderColor: 'primary.main',
              color: 'primary.main',
              '&:hover': {
                bgcolor: 'primary.lighter',
                transform: 'translateY(-1px)',
                boxShadow: '0 8px 25px rgba(67,97,238,0.15)',
              },
              textTransform: 'none',
              transition: 'all 0.2s',
              width: isMobile ? "100%" : "auto",
            }}
          >
            View Board
          </Button>
        )}

        {/* View Sprint Button - ONLY SHOW IF projectId EXISTS */}
        {projectId && (
          <Button
            variant="outlined"
            startIcon={<FlagIcon />}
            onClick={() => navigate(`/projects/${projectId}/sprints`)}
            sx={{
              height: 48,
              px: 2.5,
              borderRadius: 3,
              fontWeight: 600,
              borderColor: 'primary.main',
              color: 'primary.main',
              '&:hover': {
                bgcolor: 'primary.lighter',
                transform: 'translateY(-1px)',
                boxShadow: '0 8px 25px rgba(67,97,238,0.15)',
              },
              textTransform: 'none',
              transition: 'all 0.2s',
              width: isMobile ? "100%" : "auto",
            }}
          >
            View Sprint
          </Button>
        )}

        {/* Add Task Button */}
        {hasPermission("task.create") && (
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={onAddTask}
            sx={{
              height: 48,
              px: 3,
              borderRadius: 3,
              fontWeight: 600,
              letterSpacing: '0.5px',
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
              boxShadow: '0 4px 15px rgba(0,0,0,0.15)',
              '&:hover': {
                boxShadow: '0 8px 25px rgba(0,0,0,0.25)',
                transform: 'translateY(-1px)',
                background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
              },
              '&:active': {
                transform: 'translateY(0)',
              },
              width: isMobile ? "100%" : "auto",
            }}
          >
            Add Task
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default TaskHeader;